<template>
  <div class="flex column between" v-if="Object.keys($store.state.items).length > 0 && $store.state.show.jobsFull">
    <div class="b8">
      <div class="flex between align-center">
        <i class="indicate-text fa-2x fas fa-briefcase r16"></i>
        <input class="flexw xs-font sm-input r16" type="text" v-model="searchJobs" placeholder="Find Job">
        <i class="fas fa-times" @click="$set($store.state.show, 'jobs', false); $set($store.state.show, 'jobsFull', false)"></i>
      </div>
    </div>
    <div>
      <b>Upcoming Jobs</b>
      <div 
        @click="$set($store.state.show, 'jobs', false); $set($store.state.show, 'jobsFull', false)" 
        :key="jobKey" 
        v-for="(jobs, jobKey) in $store.state.related.jobs">
          <code class="xs-font label b8">{{jobKey.toUpperCase()}}</code>
          <div 
            :key="jobItemKey" 
            v-for="(jobItem, jobItemKey) in jobs"
            class="sm-font p4" >
            <div v-if="(!searchJobs || JSON.stringify($store.state.items[jobKey][jobItemKey]).toLowerCase().indexOf(searchJobs.toLowerCase()) > -1) && $store.state.related.jobs[jobKey][jobItemKey] !== 'notgoing'">
              <router-link 
                :to="`/i/${jobKey}/${jobItemKey}`"
                class="flex between align-center wrap b8">
                <div class="flex wrap align-center" v-if="$store.state.items[jobKey] && $store.state.items[jobKey][jobItemKey]">
                  <img v-if="$store.state.items[jobKey][jobItemKey].basics.image" class="r8" :src="$store.state.items[jobKey][jobItemKey].basics.image" style="width: 40px; height: 40px; object-fit: cover" :alt="$store.state.items[jobKey][jobItemKey].basics.title">
                  <span>{{$store.state.items[jobKey][jobItemKey].basics.title}}</span>
                </div>
                <code v-if="$store.state.items[jobKey] && $store.state.items[jobKey][jobItemKey]"><i class="fas fa-calendar r8"></i>{{$store.state.items[jobKey][jobItemKey].jobs['start-date']}}</code>
              </router-link>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div v-else>
    <code>Loading Jobs...</code>
  </div>
</template>

<script>
export default {

  name: 'jobs',
  data () {
    return {
      display: false,
      searchJobs: '',
      showJobs: false
    }
  },
  created () {
    this.$store.state.counts.cheating.jobCounts = this.$store.state.counts.cheating.jobCounts || {}
    this.$store.state.counts.cheating.jobCount = this.$store.state.counts.cheating.jobCount || {}
    Object.keys(this.$store.state.related.jobs).forEach((jobType) => {
      this.$store.state.counts.cheating.jobCounts[jobType] = Object.keys(this.$store.state.related.jobs[jobType]).length
      this.$store.state.counts.cheating.jobCount[jobType] = 0
      Object.keys(this.$store.state.related.jobs[jobType]).forEach((jobId) => {
        this.$store.state.counts.cheating.jobCount[jobType] = this.$store.state.counts.cheating.jobCount[jobType] + 1
        this.$store.dispatch('query', {
          type: 'item',
          collection: jobType,
          id: jobId
        }).then(() => {
          // this.key = Date.now()
          if (Object.keys(this.$store.state.related.jobs).length === Object.keys(this.$store.state.counts.cheating.jobCounts).length && JSON.stringify(this.$store.state.counts.cheating.jobCount) === JSON.stringify(this.$store.state.counts.cheating.jobCounts) && !this.$store.state.show.jobsFull) {
            setTimeout(() => {
              this.$store.commit('setState', {prop: 'show', prop2: 'jobsFull', val: true})
              this.$store.commit('setState', {prop: 'componentKeys', prop2: 'jobs', val: this.$store.state.componentKeys.jobs + 1})
            }, 250 + (this.$store.state.componentKeys.jobs + 1))
          }
        })
      })
    })
  }
}
</script>

<style>
  .job {
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    text-align: left;
    align-items: flex-start;
    background: rgba(0,0,0, 0.6);
    padding: 16px;
  }
  .job-title {
    text-align: center;
    width: 100%;
  }
  .job-title h1 {
    font-size: 3em;

  }
  .job-meta {
    display: flex;
    justify-content: space-between;
    width:100%;
  }
  .job-date {
    text-align: left;
  }
  .job-location {
    text-align: right;
  }
  .job-fold {
    width: 100%;
    display: flex;
    min-height: 270px;
    flex-wrap: wrap;
  }
  .job-cost {
    font-size: 1.4em
  }
  .big-money {
    font-size: 2em;
  }
  .job-img {
    width: 100%;
    min-height: 280px;
    height: auto;
    object-fit: cover;
    flex: 1 1 50%;
  }
  .job-order {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 0 16px;
    min-height:260px;
    flex: 1 1 40%;
    background: rgba(0,0,0,.8);
  }
  .job-order input {
    flex: 1;
  }
  .job-order button {
    flex: 1 1 auto;
  }
  .job-order-div {
    display: flex;
    width: 100%;
  }
  .job-content {
    width: 100%;
    
  }
</style>
